import { EspeceManagement } from '@repo/ui/features/especes/index';

export default function EssencesPage() {
  return (
    <div className="">
      <EspeceManagement />
    </div>
  );
}
